import { Image } from "antd";
import { FC } from "react";
import { TaskAddPhoto } from "tm-shared/types";

import { TaskViewModal } from "@/features/TaskView/components";
import { usePointSelector } from "@/hooks";
import { getFileUrl } from "@/utils/file/getFileUrl";

interface AddPhotoViewModalProps {
    task: TaskAddPhoto;
    onClose: () => void;
}

export const AddPhotoViewModal: FC<AddPhotoViewModalProps> = ({
    task,
    onClose,
}) => {
    const completedAt = task?.completedAt;
    const currentPoint = usePointSelector(task.targetId);

    if (!currentPoint || !completedAt) return null;

    const photo = currentPoint.market.building.photo;

    return (
        <TaskViewModal title={task.name} onClose={onClose} taskInfo={task.info}>
            <Image
                alt={currentPoint.name}
                src={getFileUrl(photo)}
                height={"auto"}
                width={"100%"}
            />
        </TaskViewModal>
    );
};
